import axios, { AxiosError } from "axios";
import i18n from "@/i18n";

const apiOrigin = (process.env.API_URL || "").replace(/\/$/, "");
export const API_ROOT = `${apiOrigin}/api`;

/** Full URL for browser navigation to start Google OAuth (`GET /api/auth/google`). */
export const getGoogleOAuthStartUrl = () => `${apiOrigin}/api/auth/google`;

const api = axios.create({
  baseURL: API_ROOT,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let onUnauthorized: (() => void) | null = null;
export function setOnUnauthorized(cb: () => void) {
  onUnauthorized = cb;
}

api.interceptors.request.use((config) => {
  const orgId = localStorage.getItem("activeOrgId");
  if (orgId) {
    config.headers["X-Organization-Id"] = orgId;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      onUnauthorized?.();
    }
    return Promise.reject(err);
  },
);

export function extractErrorMessage(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as { message?: string | string[] };
    if (data?.message) {
      return Array.isArray(data.message)
        ? data.message.join(", ")
        : data.message;
    }
    if (err.response?.status === 403) return i18n.t("errors.forbidden");
    if (err.response?.status === 404) return i18n.t("errors.notFound");
  }
  return i18n.t("errors.generic");
}

export default api;
